module.exports = __webpack_public_path__ + "static/media/lifeology-logo.4a06f8e7.svg";